import React, { useEffect, useState, useContext } from "react";
import { BACKEND_API } from "../../constants/backendApi";

//Style
import "./CreateCreditRenovationBody.css";

//Data
import createCreditRenovationData from "../../json/CreateCreditData/CreateCreditRenovationData.json";
import createCreditRenovationDataFromTable from "../../json/CreateCreditData/CreateCreditRenovationDataFromTable.json";
import createCreditRenovationDataWFESeguros from "../../json/CreateCreditData/CreateCreditWFESegurosRenovationData.json";
import createCreditRenovationDataHDI from "../../json/CreateCreditData/CreateCreditRenovationHdiData.json";
import createCreditRenovationDataMundial from "../../json/CreateCreditData/CreateCreditRenovationMundialData.json";
import createCreditRenovationDataSolidaria from "../../json/CreateCreditData/CreateCreditRenovationSolidariaData.json";

//Components
import FormWithStepsComponent from "../FormWithStepsComponent/FormWithStepsComponent";

//Context
import { LoadingContext } from "../../context/LoadingContext";
import { PopupContext } from "../../context/PopupContext";

const CreateCreditRenovationBody = ({ userData }) => {
  const token = localStorage.getItem("token");

  const isFromRenovationTable =
    localStorage.getItem("fromRenovationTable") || false;

  const { setLoading } = useContext(LoadingContext);

  const { setShowPopup } = useContext(PopupContext);

  const formId = localStorage.getItem("form_id");

  const insuranceId = localStorage.getItem("insurance_id");

  const [createCreditUserData, setCreateCreditUserData] = useState({});

  const [refreshData, setRefreshData] = useState(false);

  useEffect(() => {
    setShowPopup(false);
    setLoading(true);

    try {
      fetch(`${BACKEND_API}/api/credit-ocr?id=${formId}`, {
        method: "GET",
        credentials: "include",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => res.json())
        .then(({ data }) => {
          setCreateCreditUserData(data);
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (err) {
      console.error(err);
    }
  }, [refreshData, setLoading, setShowPopup, token]);

  const getRefreshDataState = (newState) => {
    setRefreshData(newState);
  };

  return (
    <section className="create-credit-renovation-section">
      <div className="create-credit-renovation-subcontainer">
        <div className="form-with-steps-supercontainer">
          <FormWithStepsComponent
            hasSteps={true}
            createCreditUserData={createCreditUserData}
            refreshData={refreshData}
            getRefreshDataState={getRefreshDataState}
            inputData={
              isFromRenovationTable
                ? insuranceId === "0013h00000DgTUOAA3"
                  ? createCreditRenovationDataHDI.data[0]
                  : insuranceId === "0013h00000GiwbWAAR"
                  ? createCreditRenovationDataMundial.data[0]
                  : insuranceId === "0013h00000GiwbTAAR"
                  ? createCreditRenovationDataSolidaria.data[0]
                  : createCreditRenovationDataFromTable.data[0]
                : userData?.document === "71738809"
                ? createCreditRenovationDataWFESeguros.data[0]
                : insuranceId === "0013h00000DgTUOAA3"
                ? createCreditRenovationDataHDI.data[0]
                : insuranceId === "0013h00000GiwbWAAR"
                ? createCreditRenovationDataMundial.data[0]
                : insuranceId === "0013h00000GiwbTAAR"
                ? createCreditRenovationDataSolidaria.data[0]
                : createCreditRenovationData.data[0]
            }
            hasRestoreBtn={true}
            userData={userData}
          />
        </div>
        <img
          src="https://pagina-crediseguro.s3.amazonaws.com/portal-crediseguro/assets/bgs/create-credit-deco-img.webp"
          className="profile-deco"
          alt=""
        />
      </div>
    </section>
  );
};

export default CreateCreditRenovationBody;
